import { useOrderEntryContext } from 'providers/OrderModuleProvider';
import { FC, useCallback } from 'react';
import { LocalOrderItemInput } from 'shared/models';
import { AttributeAggregateDynamicItem } from './AggregateDynamicItem';
import { findAttributeCondition } from './helper';

interface InitialDisplayAttributeProps
  extends Omit<React.ComponentPropsWithoutRef<typeof AttributeAggregateDynamicItem>, 'localTypeValue'> {
  selectedTooth: string;
  orderItemId: string;
  selectedOrderItem: LocalOrderItemInput | undefined;
  autoSelectValue?: string | null;
  parentAttributeType: string;
}
export const InitialDisplayAttribute: FC<InitialDisplayAttributeProps> = ({
  selectedTooth,
  orderItemId,
  selectedOrderItem,
  autoSelectValue,
  parentAttributeType,
  ...attribute
}) => {
  const { updateOrderItem } = useOrderEntryContext();

  const onValueChange = useCallback(() => {
    /**
     * If autoSelectValue is set, update the selected attribute with the autoSelectValue
     * and set isInvalid to false
     */
    if (selectedOrderItem && autoSelectValue && parentAttributeType) {
      const selectedAttribute = findAttributeCondition(selectedOrderItem, parentAttributeType, selectedTooth);
      if (selectedAttribute) {
        selectedAttribute.name = autoSelectValue;
        selectedAttribute.isInvalid = false;
        updateOrderItem(selectedOrderItem.id, { attributes: selectedOrderItem.attributes });
      }
    }
  }, [autoSelectValue, parentAttributeType, selectedOrderItem, selectedTooth, updateOrderItem]);

  return (
    <AttributeAggregateDynamicItem
      {...attribute}
      selectedTooth={selectedTooth}
      localTypeValue={attribute.name || ''}
      orderItemId={orderItemId}
      onValueChange={onValueChange}
    />
  );
};
